/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_CarddetailsInputs */

const en_visa_eb5_carddetails = /** @type {(inputs: Visa_Eb5_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immigrant investor classification involving qualifying investment, lawful source of funds, and required U.S. job creation.`)
};

const pt_visa_eb5_carddetails = /** @type {(inputs: Visa_Eb5_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificação para investidor imigrante envolvendo investimento qualificado, origem lícita dos recursos e criação obrigatória de empregos nos EUA.`)
};

const es_visa_eb5_carddetails = /** @type {(inputs: Visa_Eb5_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clasificación para inversionistas inmigrantes que involucra inversión calificada, origen lícito de fondos y creación obligatoria de empleos en EE. UU.`)
};

/**
* | output |
* | --- |
* | "Immigrant investor classification involving qualifying investment, lawful source of funds, and required U.S. job creation." |
*
* @param {Visa_Eb5_CarddetailsInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_carddetails = /** @type {((inputs?: Visa_Eb5_CarddetailsInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_CarddetailsInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_carddetails(inputs)
	if (locale === "es") return es_visa_eb5_carddetails(inputs)
	return en_visa_eb5_carddetails(inputs)
});